import StockClotureMoisController from './stock.cloture.mois.controller';

export default {
    template: require('./stock.cloture.mois.html'),
    controller: StockClotureMoisController
};
